import { gql } from '@apollo/client';

export const GET_INCIDENT_REVIEW = gql`
query GET_INCIDENT_REVIEW($incidentReviewId: ID!, $originatorId: ID!){
  getIncidentReview(incidentReviewId: $incidentReviewId, originatorId: $originatorId) {
    id
    approvalStatus {
      id
      name
    }
    fulfilled
    incidentDispositionType {
      id
      name
    }
    investigatingOfficer {
      id
      deptAttribute {
        id
        badge
        stateIdNumber
        ori {
          id
          oriName
          abbreviation
        }
      }
      personalAttribute{
        id
        firstName
        lastName
      }
    }
    keepInOfficerQueue
    keepInQueue
    nfirsCode {
      id
      name
    }
    nibrsReviewed
    reviewComments
    reviewDate
    reviewStatus {
      id
      name
    }
    reviewingSupervisor {
      id
      deptAttribute {
        id
        badge
        stateIdNumber
        ori {
          id
          oriName
          abbreviation
        }
      }
      personalAttribute {
        id
        firstName
        lastName
      }
    }
    sentToRecords
    sentToRecordsAt
    statusDate
    submitToOri {
      abbreviation
      agencyType
      id
      oriName
    }
    submittedAt
  }
}`;

